import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_54_564)" }, [
      _createElementVNode("path", { d: "M42.8413 16.2092L36.7905 10.1584C36.0008 9.4166 34.966 8.99097 33.8829 8.96247C32.7998 8.93396 31.744 9.30458 30.9163 10.0038L11.0413 29.8788C10.3275 30.5986 9.88308 31.5421 9.7826 32.5509L8.83301 41.7596C8.80326 42.0831 8.84523 42.4091 8.95593 42.7145C9.06663 43.0199 9.24332 43.2971 9.47343 43.5263C9.67978 43.731 9.92449 43.8929 10.1936 44.0028C10.4626 44.1127 10.7507 44.1684 11.0413 44.1667H11.2401L20.4488 43.3276C21.4576 43.2271 22.4011 42.7826 23.1209 42.0688L42.9959 22.1938C43.7673 21.3789 44.1842 20.2913 44.1553 19.1696C44.1263 18.0478 43.6538 16.9833 42.8413 16.2092ZM35.333 23.5851L29.4147 17.6667L33.7209 13.2501L39.7497 19.2788L35.333 23.5851Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_54_564" }, [
        _createElementVNode("rect", {
          width: "53",
          height: "53"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }